<template>
    <!--查看地图-->
    <div class="mapShow">
        <div>
            <slot name="openmap">
                <span class="goMap" @click="showMap">{{isEdit?'标记地图':'查看地图'}}</span>
                <span>({{lng}},{{lat}})</span>
                <a v-if="isEdit" href="javascript:void(0)" @click="clearLOLA">清除</a>
            </slot>
        </div>
        <transition name="fade">
            <div class="mapBox" v-if="isShowMap">
                <div class="mapTop">
                    <!--<span class="mapTip">请拖动绿色工程标识图标或点击地图到目标位置</span>-->
                    <span class="mapClosed" @click="showMap"><Icon type="md-close-circle" /></span>
                </div>
                <div class="mapArea">
                    <div v-if="isEdit">
                        <el-amap-search-box class="map-search-box"
                                            :on-search-result="onSearchResult"></el-amap-search-box>
                    </div>
                    <el-amap vid="amapDemo" :plugin="plugin" :zoom="zoom" :center="center" :events="events">
                        <el-amap-marker v-for="(marker,index) in markers" :key="index" :position="marker.position" :events="marker.events"  :draggable="marker.draggable" >
                            <div :style="slotStyle"></div>
                        </el-amap-marker>
                    </el-amap>
                </div>
            </div>
        </transition>

    </div>

</template>

<script>
    export default {
        data(){
            let self=this;
            return{
                /*地图区*/
                isShowMap:false,
                /*地图配置*/
                zoom: 14,
                lng:0,
                lat:0,
                // lng:114.352482,
                // lat:36.103442,
                center:[0,0],
                loaded: false,
                slotStyle: {
                    'width':'32px', 'height':'32px',
                    'background-image': 'url("/src/assets/map-td.png")',
                    'background-repeat':'no-repeat' ,
                },
                events: {
                    init: (map) => {
                        if(self.lng && self.lat){
                            self.center=[self.lng,self.lat];
                            self.markers[0].position=[self.lng,self.lat];
                        }else {
                            map.setCity(self.defaultCity);
                        }
                    },
                    'click': (e) => {
                        if(self.isEdit){
                            self.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
                            self.lng=e.lnglat.lng;
                            self.lat=e.lnglat.lat;
                        }
                    }
                },
                markers: [
                    {
                        position: [0,0],
                        events: {
                            dragend: (e) => {
                                self.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
                                self.lng=e.lnglat.lng;
                                self.lat=e.lnglat.lat;

                            }
                        },
                        draggable: self.isEdit,
                    }
                ],
                plugin: [
                    {
                        pName: 'Scale',

                    },
                    {
                        pName: 'ToolBar',
                    },
                ],

            };
        },

        props: {
            /*经度*/
            longitude:{
                type: [String, Number],
            },
            /*纬度*/
            latitude:{
                type: [String, Number],
            },
            /*默认搜素地*/
            defaultCity:{
                type:String,
            },
            isEdit:{
                type: Boolean,
                default:true,
            },
        },
        watch:{
            lng: function() {
                this.$emit('update:longitude', this.lng);
            },
            lat: function() {
                this.$emit('update:latitude', this.lat);
            },
            /*监听 不考虑经纬度 0 0 */
            longitude: function() {
                (this.longitude) && (this.lng=this.longitude);
            },
            latitude: function() {
                (this.latitude) && (this.lat=this.latitude);
            },
        },
        mounted (){
            (this.longitude) && (this.lng=this.longitude);
            (this.latitude) && (this.lat=this.latitude);
        },
        methods:{
            /*展示地图*/
            showMap(){
                this.isShowMap=!this.isShowMap;
            },
            /*清除坐标*/
            clearLOLA(){
                this.lng=0;
                this.lat=0;
            },
            /*地图搜索*/
            onSearchResult(pois) {
                if (pois.length > 0) {
                    let center = {
                        lng: pois[0].lng,
                        lat: pois[0].lat
                    };
                    this.center = [center.lng, center.lat];
                    this.markers[0].position = [center.lng, center.lat];
                    this.lng=center.lng;
                    this.lat=center.lat;
                }
            },
        },
    };
</script>
<style scoped>
    /*地图区*/
    .mapShow{
        position: relative;
    }
    .goMap{
        color: #189DFF;
        cursor: pointer;
    }
    .mapBox{
        position: absolute;
        top: 30px;left:-100px;z-index: 200;
        width: 540px;height: 380px;
        background-color: #fff;
        border: 3px solid rgba(165,174,179,0.4);
        border-top-width: 15px;border-right-width: 10px;
    }
    .mapTop{
        background-color: #DBDBDB;
        line-height: 20px;
        margin: 1px;
    }
    .mapClosed {
        position: absolute;
        top: -14px;
        right: -7px;
        font-size: 20px;
        cursor: pointer;
        z-index: 5;
    }
    .mapArea{
        position: relative;
        height: 100%;
    }
    .map-search-box{
        position: absolute !important;
        top: 10px; left: 80px;
        width: 340px !important; height: 40px !important;
    }
    .el-vue-search-box-container .search-box-wrapper .search-btn{
        margin-bottom: 0;
    }
</style>
